import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Modal,
  Space,
  Table,
  Spin,
  Popconfirm,
  Collapse,
  Popover,
  Typography,
} from 'antd'
import { CloseCircleOutlined, DeleteFilled } from '@ant-design/icons'
import {
  getRegisteredPatients,
  deleteRegisteredPatient,
  sendPatientAuthLink,
} from '../../store/action/patient.action'
import _ from 'lodash'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import util from '../../util/util'
import moment from 'moment'
import { loginAsCustomer } from '../../store/action/profile.action'
import { Link } from 'react-router-dom'
import { constants } from '../../constants'
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
var form = null

const AddPatient = (props) => {
  const [open, setOpen] = useState(false)
  var history = useHistory()
  const [spin, setSpin] = useState(false)
  const companyAdmin = props.currentUserRole == constants.ROLE.COMPANY_ADMIN
  const [popoverVisible, setPopoverVisible] = useState(false)
  const [linkform] = Form.useForm()
  useEffect(() => {
    handleModalOpen()
    setSpin(true)
    props
      .fetchPatient(
        {
          filters: {},
          metadata: { pageSize: 5, current: 1 },
          customerid: companyAdmin ? props.customer?._id : null,
          sorter: props.sorter,
        },
        {}
      )
      .then((res) => setSpin(false))
  }, [open])

  var fetchPatientList = (pagination, filters, sorter) => {
    setSpin(true)
    props
      .fetchPatient(
        {
          metadata: pagination || props.pagination,
          filters: props.filters,
          customerid: companyAdmin ? props.customer?._id : null,
          sorter: props.sorter,
        },
        {}
      )
      .then((res) => setSpin(false))
  }
  var onFinish = (data) => {
    form.validateFields().then((data) => {
      setSpin(true)
      var values = _.pickBy(data, _.identity)
      if (values.lastname_plain)
        values.lastname_plain = values.lastname_plain.trim()

      props
        .fetchPatient(
          {
            filters: values,
            metadata: { pageSize: 5, current: 1 },
            customerid: companyAdmin ? props.customer?._id : null,
            sorter: props.sorter,
          },
          {}
        )
        .then((res) => setSpin(false))
    })
  }

  var handleModalOpen = () => {
    form &&
      form.setFieldsValue({
        ...props.filters,
      })
  }

  const addPatient = (patient) => {
    patient.regid = patient._id
    delete patient._id
    history.push({ pathname: '/patient/add/info', state: { patient } })
  }
  var pagination = {
    ...props.pagination,
    pageSize: 5,
    pageSizeOptions: [5],
  }

  const handleDelete = (id) => {
    props.deletePatient(id)
    fetchPatientList()
  }

  const columns = [
    {
      title: 'Patient Name',
      dataIndex: 'firstname',
      key: 'firstname',
      render: (text, record) => <>{record.firstname + ' ' + record.lastname}</>,
    },
    {
      title: 'DOB',
      dataIndex: 'dob',
      key: 'dob',
      render: (text) => <>{moment(text).format('MM/DD/YYYY')}</>,
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (text) => <>{text}</>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Button
            onClick={() => {
              addPatient(record)
            }}
          >
            Add
          </Button>
          <Popconfirm
            title='Delete Patient'
            description='Are you sure to delete this patient?'
            onConfirm={() => handleDelete(record._id)}
            onCancel={() => {}}
            okText='Yes'
            cancelText='No'
          >
            <DeleteFilled style={{ fontSize: '12px' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  const sendPatientAuthLink = async (values) => {
    let data = await props.sendPatientAuthLink({
      ...values,
      customerid: companyAdmin ? props.customer?._id : null,
    })
    if (data) setPopoverVisible(false)
  }

  const handleQrCode = () => {
    if (!props.customer?._id) return
    const qrCodeUrl = `${constants.API_URL}/registerform/${props.customer._id}`
    window.open(qrCodeUrl, '_blank', 'noopener,noreferrer')
  }

  const renderSendLinkForm = () => {
    return (
      <div className='sendLinkForm'>
        <Typography.Title level={5}>
          Send link to authorization forms to patient
        </Typography.Title>
        <Form
          form={linkform}
          onFinish={sendPatientAuthLink}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
        >
          <Form.Item
            label="Patient's Phone"
            name='phone'
            rules={[
              () => ({
                validator(rule, value) {
                  // if(!value) return Promise.reject(new Error("Please enter patient phone number."));;
                  const parsedNumber = value
                    ? parsePhoneNumber(value, 'US')
                    : null
                  if (
                    parsedNumber &&
                    parsedNumber.country === 'US' &&
                    isValidPhoneNumber(value)
                  ) {
                    return Promise.resolve()
                  }

                  return Promise.reject(
                    new Error('Please enter a valid U.S. phone number.')
                  )
                },
              }),
            ]}
          >
            <PhoneInput
              addInternationalOption={false}
              initialValueFormat='national'
              defaultCountry='US'
              className='phone-input fullWidth'
              enableAreaCodes
              countries={['US']}
              international={false}
            />
          </Form.Item>

          <Form.Item
            label="Patient's Email"
            name='email'
            rules={[
              {
                required: false,
                whitespace: true,
                message: 'Please enter valid email',
                type: 'email',
              },
            ]}
          >
            <Input maxLength={200} />
          </Form.Item>

          <Row>
            <Col span={8}>
              <Button type='primary' onClick={handleQrCode}>
                View QR
              </Button>
            </Col>
            <Col span={8} offset={8}>
              <Button type='primary' htmlType='submit'>
                Send Link
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }

  var renderCard = () => {
    return (
      <>
        <Card bordered={false}>
          <Row style={{ marginBottom: 20 }}>
            <Col md={24}>
              Pateint must first complete the authorization forms before they
              are added. <spa>&nbsp;</spa>
              <Popover
                content={renderSendLinkForm()}
                visible={popoverVisible}
                onVisibleChange={(v) => setPopoverVisible(v)}
                trigger={'click'}
              >
                <Link
                  onClick={() => {
                    linkform.resetFields()
                  }}
                >
                  Send form to Patient
                </Link>
              </Popover>
            </Col>
          </Row>
          <Row justify={'center'} gutter={24}>
            <Col md={12}>
              <Form
                ref={(e) => (form = e)}
                name='normal_login'
                layout='horizontal'
              >
                <Form.Item
                  rules={[
                    {
                      whitespace: true,
                      message: 'Please remove empty spaces.',
                    },
                  ]}
                  name='lastname_plain'
                  label='Search'
                >
                  <Input
                    type='lastname_plain'
                    placeholder='Enter Last Name/Last four digits of phone'
                  />
                </Form.Item>
              </Form>
            </Col>

            <Col md={4}>
              <Button
                className={'actionBtn'}
                justify={'end'}
                onClick={() => {
                  onFinish()
                }}
              >
                Search
              </Button>
            </Col>
          </Row>
          <Spin spinning={spin}>
            <Row style={{ overflow: 'scroll' }}>
              <Table
                columns={columns}
                style={{ width: '100%', marginTop: '10px' }}
                dataSource={props.patients}
                pagination={pagination}
                onChange={fetchPatientList}
              />
            </Row>
          </Spin>
        </Card>
      </>
    )
  }

  return (
    <>
      <Row align={'end'}>
        <Col>
          <Row justify={'end'}>
            <Button
              className={'actionBtn'}
              onClick={() => {
                setOpen(true)
              }}
            >
              ADD
            </Button>
          </Row>
        </Col>
      </Row>
      <Modal
        title='REGISTERED PATIENTS'
        centered
        className={'filterModal'}
        visible={open}
        closable={true}
        maskClosable={false}
        keyboard={false}
        width={'20%'}
        okText={'Create Patient'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
        footer={[
          <div>
            <Link to='/patient/add/info'>
              <Button
                style={{
                  backgroundColor: '#001529',
                  color: 'white',
                  width: 'fit-content',
                }}
                className={'actionBtn'}
              >
                Add Patient Without Authorization Form
              </Button>
            </Link>
            <Button
              key='cancel'
              onClick={() => setOpen(false)}
              style={{ marginLeft: '10px' }}
            >
              Close
            </Button>
          </div>,
        ]}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

AddPatient.propTypes = {
  fetchPatient: PropTypes.func.isRequired,
  patients: PropTypes.array,
  filters: PropTypes.object,
  sorter: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    filters: state.patient.companyPatientFilter,
    patients: state.patient.companyPatients,
    pagination: state.patient.companyMetaData,
    sorter: state.patient.sorter,
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    currentUserRole: state.profile?.user?.role,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (params, patients) => dispatch(getRegisteredPatients(params)),
    deletePatient: (params) => dispatch(deleteRegisteredPatient(params)),
    loginAsCustomer: (params) => dispatch(loginAsCustomer(params)),
    sendPatientAuthLink: (params) => dispatch(sendPatientAuthLink(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPatient)
